export class RadioList {
	private allInputs: HTMLInputElement[];
	constructor(anyInput: HTMLInputElement) {
		// @ts-ignore
		this.allInputs = anyInput.form?.querySelectorAll("[name='" + anyInput.name + "']") || [];
		for(const inp of this.allInputs) inp.addEventListener('change',
			(ev) => this.onChange && this.onChange(this.value, ev)
		);
	}

	get value(): string|null {
		for(const inp of this.allInputs) if  (inp.checked) return inp.value;
		return null;
	}

	set value(v: string|null) {
		for(const inp of this.allInputs) inp.checked = inp.value === v;
	}

	public onChange: ((value: string|null, ev: Event) => void)|null = null;
}